import InStatistical from "../page/report/inventory/Statistical.vue"
import ConAnalyse from "../page/report/member/conAnalyse.vue"
import Statistics from "../page/report/member/add/Statistics"
import ConSummary from "../page/report/member/consumption/Summary"
import InPreview from "../page/report/inventory/Preview"
import MePreview from "../page/report/member/Preview"
import Use from "../page/report/member/integral/Use"
import Mall from "../page/report/sales/Mall"
import Trend from "../page/report/sales/Trend"
import Proportion from "../page/report/sales/Proportion"
import Statistical from "../page/report/sales/Statistical"
import Discount from "../page/report/sales/Discount"
import Warning from "../page/report/inventory/Warning"
import Analyse from "../page/report/inventory/Analyse"
import OrderAnalyse from "../page/report/member/order/OrderAnalyse"
import DepositStatistics from "../page/report/member/deposit/DepositStatistics"
import Detail from "../page/report/member/topUp/Detail"
import Distribution from "../page/report/member/integral/Distribution"
import Reconciliation from "../page/report/member/Reconciliation"

export const report = [{
  path: '/report/inventory/statistical',
  name: 'InStatistical',
  component: InStatistical,
  meta: {
    requireAuth: true,
    title: '库存统计'
  }
},
{
  path: '/report/member/constitute/analyse',
  name: 'ConAnalyse',
  component: ConAnalyse,
  meta: {
    requireAuth: true,
    title: '会员构成分析'
  }
},
{
  path: '/report/member/add/Statistics',
  name: 'Statistics',
  component: Statistics,
  meta: {
    requireAuth: true,
    title: '会员增长统计'
  }
},
{
  path: '/report/member/consumption/Summary',
  name: 'ConSummary',
  component: ConSummary,
  meta: {
    requireAuth: true,
    title: '会员消费汇总'
  }
},
{
  path: '/report/inventory/Preview',
  name: 'Preview',
  component: InPreview,
  meta: {
    requireAuth: true,
    title: '商品概览'
  }
},
{
  path: '/report/member/Preview',
  name: 'Preview',
  component: MePreview,
  meta: {
    requireAuth: true,
    title: '会员概览'
  }
},
{
  path: '/report/sales/Mall',
  name: 'Mall',
  component: Mall,
  meta: {
    requireAuth: true,
    title: '商城概览'
  }
},

{
  path: '/report/member/integral/Use',
  name: 'Use',
  component: Use,
  meta: {
    requireAuth: true,
    title: '积分使用记录'
  },
},
{
  path: '/report/sales/Trend',
  name: 'Trend',
  component: Trend,
  meta: {
    requireAuth: true,
    title: '营业趋势分析'
  },
},
{
  path: '/report/sales/Proportion',
  name: 'Proportion',
  component: Proportion,
  meta: {
    requireAuth: true,
    title: '营业占比分析'
  },
},
{
  path: '/report/sales/Statistical',
  name: 'Statistical',
  component: Statistical,
  meta: {
    requireAuth: true,
    title: '商品销售统计'
  },
},
{
  path: '/report/sales/Discount',
  name: 'Discount',
  component: Discount,
  meta: {
    requireAuth: true,
    title: '折扣分析'
  },
},
{
  path: '/report/inventory/Warning',
  name: 'Warning',
  component: Warning,
  meta: {
    requireAuth: true,
    title: '库存预警'
  },
},
{
  path: '/report/inventory/Analyse',
  name: 'Analyse',
  component: Analyse,
  meta: {
    requireAuth: true,
    title: '商品分析'
  },
},
{
  path: '/report/member/order/analyse',
  name: 'OrderAnalyse',
  component: OrderAnalyse,
  meta: {
    requireAuth: true,
    title: '客单价分析'
  },
},
{
  path: '/report/member/deposit/statistics',
  name: 'DepositStatistics',
  component: DepositStatistics,
  meta: {
    requireAuth: true,
    title: '会员储值统计'
  },
},
{
  path: '/report/member/deposit/statistics',
  name: 'DepositStatistics',
  component: DepositStatistics,
  meta: {
    requireAuth: true,
    title: '会员储值统计'
  },
},
{
  path: '/report/member/topUp/Detail',
  name: 'Detail',
  component: Detail,
  meta: {
    requireAuth: true,
    title: '会员充值明细'
  },
},
{
  path: '/report/member/integral/Distribution',
  name: 'Distribution',
  component: Distribution,
  meta: {
    requireAuth: true,
    title: '积分分布'
  },
},
{
  path: '/report/member/Reconciliation',
  name: 'Reconciliation',
  component: Reconciliation,
  meta: {
    requireAuth: true,
    title: '会员对账'
  },
},
];



// WEBPACK FOOTER //
// ./src/router/report.route.js